import { useCultureCode } from '@mews-commander/core';
import { getCurrencyCultureInfo } from '@mews-commander/core/legacy-globalization';
import { useCommanderSelector } from '@mews-commander/utils';
import { NumberService, useLocalizeCurrency, useLocalizePercentage } from '@mews/framework';

export interface PercentageValue {
    discriminator: 'Percentage';
    value: { value: number };
}

export interface FlatValue {
    discriminator: 'Flat';
    value: {
        value: number;
        currencyCode?: string;
    };
}

type SettlementRuleValueProps = PercentageValue | FlatValue;

export const useSettlementRuleValueGetter = () => {
    const localizePercent = useLocalizePercentage();
    const localizeCurrency = useLocalizeCurrency();

    const cultureCode = useCultureCode();
    const currencyCultureInfo = useCommanderSelector((state) => getCurrencyCultureInfo(state, { cultureCode }));

    return (props: SettlementRuleValueProps) => {
        switch (props.discriminator) {
            case 'Percentage':
                return localizePercent(props.value.value);
            case 'Flat':
                return props.value.currencyCode
                    ? localizeCurrency(props.value.value, props.value.currencyCode)
                    : NumberService.formatCurrencyValue(props.value.value, currencyCultureInfo, {
                          precision: 2,
                          showSymbol: false,
                      });
        }
    };
};

export const SettlementRuleValue = (props: SettlementRuleValueProps) => {
    const getSettlementRuleValue = useSettlementRuleValueGetter();
    return <span>{getSettlementRuleValue(props)}</span>;
};
